import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';

/**
 * The failed filter enumerations
 *
 * @type {Object}
 */
export const FREELANCER_SEARCH_RESULT__FAILED_FILTER_NAMES = {
  RATE: 'RATE',
  UNSUBSCRIBED: 'UNSUBSCRIBED'
};

const FreelancerSearchResult = ShModel.extend({
  // attributes
  currentDistance: attr('number'),
  distance: attr('number'),
  failedSearchFilters: attr('failed-search-filters'),
  hasApplied: attr('boolean'),
  homeDistance: attr('number'),
  userDaysSinceSeen: attr('number'),
  userEmail: attr('string'),
  userId: attr('string'),
  userLastLocation: attr('string'),
  userLocation: attr('string'),
  userName: attr('string'),
  userNotifiedCount: attr('number'),
  userRating: attr('number'),
  userSlug: attr('string'),

  // relationships
  failedResult: belongsTo('freelancerSearchResultCollection', { async: false }),
  result: belongsTo('freelancerSearchResultCollection', { async: false }),
});

export default FreelancerSearchResult;
